export default class TaskDetailMsgsController {
  constructor(Comments) {
    'ngInject'

    this.Comments = Comments;
  }

  onCommentSubmit(comment) {
    this.task.comments.unshift(comment);

    this.Comments.create(comment)
      .then((message) => {
        this.task.comments[0] = message;
      })
      .catch(() => this.task.comments.shift());
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/screens/task-detail-msgs/task-detail-msgs.controller.js